import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownSmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.28125 12.7188L4.28125 7.71875C3.875 7.34375 3.875 6.6875 4.28125 6.3125C4.65625 5.90625 5.3125 5.90625 5.6875 6.3125L10 10.5938L14.2812 6.3125C14.6562 5.90625 15.3125 5.90625 15.6875 6.3125C16.0938 6.6875 16.0938 7.34375 15.6875 7.71875L10.6875 12.7188C10.3125 13.125 9.65625 13.125 9.28125 12.7188Z"
	})
});
const ForwardRef = forwardRef(SvgArrowDownSmall);
export default ForwardRef;
